module.exports = __webpack_public_path__ + "img/kaguya houraisan_sc2.d72461c0.png";